import React from 'react'
import Products from '../components/Products'

const SmartCardPage = () => {
    return (
        <>
            <Products />
        </>
    )
}

export default SmartCardPage